import { useEffect } from 'react';
import { useAppDispatch } from '@/store';
import { setOnline, setOffline } from '@/store/slices/app/networkStatus';

/**
 * Registers window online/offline event listeners and keeps the Redux
 * networkStatus slice in sync. Call this once inside a component that is
 * always mounted (e.g. a page-level ActionsPanel).
 */
export const useOnlineStatus = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleOnline = () => dispatch(setOnline());
    const handleOffline = () => dispatch(setOffline());

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Sync initial state in case the component mounts while already offline
    if (!navigator.onLine) {
      dispatch(setOffline());
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [dispatch]);
};
